/* eslint-disable no-param-reassign */

import { Deserializer } from 'jsonapi-serializer';
import Swiper, { Navigation, Pagination, Autoplay } from 'swiper';

const apiUrl = window.gon && window.gon.global.advert.apiUrl;
const bannerPositions = document.querySelectorAll('.js-related-img');
const currentLocale = window.location.pathname.substring(1, 3);

const renderSlide = ({ image_url, logo_url, company_url, text, url, target_blank }) => `
  <div class="swiper-slide sponsor__wrapper">
    <a href="${url}?locale=${currentLocale}" ${target_blank ? 'target="_blank"' : ''}>
      <img src="${image_url}" alt="">
      
      ${text ? `<div class="sponsor__text-wrapper">
        <span class="hidden sponsor__text">${text}</span>
      </div>` : ''}

      ${(!company_url && logo_url) ? `<div class="hidden sponsor__logo">
        <img src="${logo_url}" alt="">
      </div>` : ''}
    </a>
    ${(company_url && logo_url) ? `<a href="${company_url}" ${target_blank ? 'target="_blank"' : ''} class="hidden sponsor__logo" style="${!company_url && 'display: none'}">
      <img src="${logo_url}" alt="">
    </a>` : ''}
  </div>
`;

const renderSlider = banners => `
  <div class="swiper-wrapper">${banners.map(banner => renderSlide(banner, 'slider')).join('')}</div>
  <div class="swiper-pagination"></div>
  <div class="swiper-button-prev"></div>
  <div class="swiper-button-next"></div>
`;

const buildBanners = ({ active_postings }) => active_postings.map(p => ({
  url: p.banner.url,
  image_url: p.banner[`image_${currentLocale}_url`],
  logo_url: p.banner.logo_url,
  company_url: p.banner.company_url,
  target_blank: p.banner.target_blank,
  text: p.banner[`text_${currentLocale}`],
  position: p.position ?? 999
}));

const layoutWrapper = (item, callback) => {
  const banners = buildBanners(item);
  const bannerEl = document.querySelector(`div[data-slug=${item.slug}]`);

  if (bannerEl) {
    if (banners.length) {
      bannerEl.classList.remove('hidden');
      callback(banners, bannerEl);
    }
  }
};

const layoutSlider = item => layoutWrapper(item, (banners, el) => {
  el.innerHTML = renderSlider(banners.sort(() => Math.random() - 0.5));
  el.classList.add('swiper');
  const elementsCount = banners.length;

  // eslint-disable-next-line no-new
  new Swiper(el, {
    modules: [Navigation, Pagination, Autoplay],
    spaceBetween: elementsCount > 1 ? 24 : 0,
    pauseOnMouseEnter: true,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
      disabledClass: 'disabled'
    },
    pagination: {
      el: '.swiper-pagination',
      type: 'bullets',
      clickable: true,
      bulletActiveClass: 'active'
    },
    autoplay: {
      delay: 5000
    },
    breakpoints: {
      767: { slidesPerView: 2 },
      1210: { slidesPerView: 3 }
    }
  });
});

const layoutRandom = item => layoutWrapper(item, (banners, el) => {
  const banner = banners[Math.floor(Math.random() * banners.length)];

  el.innerHTML = renderSlide(banner, 'random');
});

const handleBanners = items => items.forEach(item => {
  switch (item.layout) {
  case 'slider':
    layoutSlider(item);
    break;

  default: // random
    layoutRandom(item);
    break;
  }
});

const filters = (banners) => {
  const slugs = Array.from(banners).map(banner => banner.dataset.slug).join();
  let result = '';
  if (slugs) result = `&filter[slug]=${slugs}&locale=${currentLocale}`;
  return result;
};

const fetchBanners = async (banners) => {
  try {
    const response = await fetch(`${apiUrl}/places?include=active_postings.banner${filters(banners)}`);
    const items = await new Deserializer({ keyForAttribute: 'snake_case' }).deserialize(await response.json());
    const localizedItems = items.map(item => {
      const active_postings = item.active_postings.filter(item => item.banner[`url_${currentLocale}`].length > 0);

      if (active_postings.length > 0) return {
        layout: item.layout,
        slug: item.slug,
        active_postings
      };
    });

    handleBanners(localizedItems.filter(item => item !== undefined));

  } catch (error) {
    console.error(`Can't fetch data: ${error.message}`);
  }
};

if (bannerPositions.length) fetchBanners(bannerPositions);

const adjustFontSize = () => {
  const wrappers = document.querySelectorAll('.sponsor__wrapper');
  wrappers.forEach(wrapper => {
    const textElement = wrapper.querySelector('.sponsor__text');
    const logoElement = wrapper.querySelector('.sponsor__logo');
    const blockWidth = wrapper.offsetWidth;
    const blockHeight = blockWidth / 16 * 9;

    if (textElement) {
      const fontSize = Math.max(10, Math.min(blockWidth * 0.042, 24));
      textElement.style.fontSize = `${fontSize}px`;
      textElement.classList.remove('hidden');
    }

    if (logoElement) {
      const size = Math.max(64, Math.min(blockHeight * 0.245, 80));
      logoElement.style.width = `${size}px`;
      logoElement.style.height = `${size}px`;
      logoElement.classList.remove('hidden');
    }
  });
};

const observer = new MutationObserver(mutations => {
  mutations.forEach(mutation => {
    if (mutation.type === 'childList') {
      const addedNodes = Array.from(mutation.addedNodes);
      addedNodes.forEach(node => {
        if (node.classList && node.classList.contains('sponsor__wrapper')) adjustFontSize();
      });
    }
  });
});

observer.observe(document.body, { childList: true, subtree: true });
window.addEventListener('resize', adjustFontSize);
